
import { PropType, computed, defineComponent, onMounted } from "vue";
import OutOfProductionNav from "@/Components/Reports/OutOfProductionNav.vue";
import Product from "@/types/Product";
import Pagination from "@/types/Pagination";
import ProductList from "@/Components/Product/ProductList.vue";
import dayjs from "dayjs";

export default defineComponent({
  props: {
    products: {
      type: Object as PropType<Pagination<Product>>,
      required: false,
      default: () => [],
    },
    isAdmin: {
      type: Boolean,
      default: () => false,
    },
    type: {
      type: String,
    },
  },
  setup(props) {
    onMounted(() => {
      window.print();
    });

    const typeText = computed(() => {
      switch (props.type) {
        case "week":
          return "Siste 7 dager";

        case "weeks":
          return "Siste 14 dager";

        case "month":
          return "Siste 30 dager";
      }
    });

    const fromDate = computed(() => {
      switch (props.type) {
        case "week":
          return dayjs().subtract(7, "days");

        case "weeks":
          return dayjs().subtract(14, "days");

        case "month":
          return dayjs().subtract(30, "days");
      }
    });

    return {
      typeText,
      dayjs,
      fromDate,
    };
  },
  components: { OutOfProductionNav, ProductList },
});
